import { render, staticRenderFns } from "./AdjuntoDataCA.vue?vue&type=template&id=11148422&"
import script from "./AdjuntoDataCA.vue?vue&type=script&lang=js&"
export * from "./AdjuntoDataCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports